import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ErrorDialogBuilder } from '../../../dialog/components/error-dialog/error-dialog.builder';
import {
  I2gNgTrackingActionBuilder,
  ITrackingAction,
  ITrackingObject,
} from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';
import { VerifyAccountDispatcher } from '../../verify-account.dispatcher';

const BUTTON_IDENTIFIER = 'resend_verification_email';

@Component({
  selector: 'app-verify-email-notification',
  templateUrl: './verify-email-notification.component.html',
  styleUrls: ['./verify-email-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ErrorDialogBuilder],
})
export class VerifyEmailNotificationComponent implements OnInit {
  trackingObject: ITrackingObject;
  trackingAction: ITrackingAction;

  @Input() message: string;
  @Input() trackingScreenName: string;

  constructor(
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingDispatcher: TrackingDispatcher,
    private _verifyAccountDispatcher: VerifyAccountDispatcher
  ) {}

  ngOnInit() {
    this.trackingAction = this._trackingActionBuilder.buildButtonTapped(
      BUTTON_IDENTIFIER,
      this.trackingScreenName
    );
    this.trackingObject = this._trackingObjectBuilder.buildAlertBanner();

    this._trackingDispatcher.trackEvent(
      this.trackingObject,
      this._trackingActionBuilder.buildPresented(this.trackingScreenName),
      { identifier: BUTTON_IDENTIFIER }
    );
  }

  onResendEmail() {
    this._trackingDispatcher.trackEvent(
      this.trackingObject,
      this.trackingAction
    );
    this._verifyAccountDispatcher.resendVerificationEmail();
  }
}
